import { CapacitorBarcodeScanner, CapacitorBarcodeScannerTypeHintALLOption } from '@capacitor/barcode-scanner';

export const useBarcodeScanner = () => {
	const isScanning = ref(false);
	const scanResult = ref<string | null>(null);
	const error = ref<string | null>(null);

	const startScan = async () => {
		if (import.meta.server) return;

		try {
			error.value = null;
			scanResult.value = null;
			isScanning.value = true;

			const result = await CapacitorBarcodeScanner.scanBarcode({
				hint: CapacitorBarcodeScannerTypeHintALLOption.ALL,
				scanInstructions: 'Наведите камеру на штрихкод',
				scanButton: true
			});

			if (result && result.ScanResult) {
				scanResult.value = result.ScanResult;
			}

			return scanResult.value;
		} catch (err: any) {
			error.value = err.message || 'Сканирование отменено или произошла ошибка';
			console.error('Barcode Scanner Error:', err);
			return null;
		} finally {
			isScanning.value = false;
		}
	};

	return {
		isScanning,
		scanResult,
		error,
		startScan
	};
};
